import { useMutation, useQueryClient } from "react-query";
import { ITagValue } from "../../common/models/ITagValue";
import ManualEntryDataService from "../../services/manual-entry-data-service/ManualEntryDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys as tagHistoryKeys } from "../tag-history/Keys";
import { keys as tagManualEntryKeys } from "./Keys";

export type UseUpdateTagValuesParameters = {
    groupID: number,
    convertToContractDay?: boolean,
} & BaseUseMutationParameters<void, Array<ITagValue>>;

export function useUpdateTagValues({
    groupID,
    convertToContractDay,
    onError,
    onSuccess
}: UseUpdateTagValuesParameters) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, Array<ITagValue>>(
        (values) => {
            return ManualEntryDataService.updateTagValue(
                groupID,
                values,
                convertToContractDay
            );
        },
        {
            onError: onError,
            onSuccess: onSuccess,
            onSettled: () => {
                queryClient.invalidateQueries(tagManualEntryKeys.tagManualEntries());
                queryClient.invalidateQueries(tagHistoryKeys.histories());
            }
        }
    );
}